import axiosInstance from './AxiosInstance';

const MenuService = {
  // Public: Get menu for a role
  getMenuByRole: async (roleCode) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/role/${roleCode}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch menu by role";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  // Management: CRUD menu items
  getAllItems: async () => {
    try {
      const response = await axiosInstance.get('/menu-configuration/items');
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch menu items";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  getItem: async (id) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/items/${id}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch menu item";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  createItem: async (payload) => {
    try {
      const response = await axiosInstance.post('/menu-configuration/items', payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to create menu item";
      const validationErrors = error.response?.data?.errors || [];
      throw {
        message: errorMessage,
        validationErrors: validationErrors,
        status: error.response?.status
      };
    }
  },

  updateItem: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/menu-configuration/items/${id}`, payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update menu item";
      const validationErrors = error.response?.data?.errors || [];
      throw {
        message: errorMessage,
        validationErrors: validationErrors,
        status: error.response?.status
      };
    }
  },

  deleteItem: async (id) => {
    try {
      const response = await axiosInstance.delete(`/menu-configuration/items/${id}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to delete menu item";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  // Role assignments
  getAssignments: async (menuId) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/items/${menuId}/roles`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch assignments";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  assignRole: async (payload) => {
    try {
      const response = await axiosInstance.post('/menu-configuration/assignments', payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to assign role";
      const validationErrors = error.response?.data?.errors || [];
      throw {
        message: errorMessage,
        validationErrors: validationErrors,
        status: error.response?.status
      };
    }
  },

  updateAssignment: async (id, payload) => {
    try {
      const response = await axiosInstance.put(`/menu-configuration/assignments/${id}`, payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update assignment";
      const validationErrors = error.response?.data?.errors || [];
      throw {
        message: errorMessage,
        validationErrors: validationErrors,
        status: error.response?.status
      };
    }
  },

  removeAssignment: async (id) => {
    try {
      const response = await axiosInstance.delete(`/menu-configuration/assignments/${id}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to remove assignment";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  // Get parent menus
  getParentMenus: async () => {
    try {
      const response = await axiosInstance.get('/menu-configuration/parent-menus');
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch parent menus";
      throw {
        message: errorMessage,
        status: error.response?.status
      };
    }
  },

  // Get menu configuration for route access control
  getMenuConfiguration: async (roleCode) => {
    try {
      const response = await axiosInstance.get(`/menu-configuration/role/${roleCode}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to fetch menu configuration";
      console.error('Menu configuration error:', errorMessage);
      return {
        success: false,
        message: errorMessage,
        status: error.response?.status
      };
    }
  }
};

export default MenuService;
